<template>
  <div class="about">
    <!-- id="cContent" -->
    <div class="cContent">
      <div id="elInput">
        <el-input
          class="input-with-select"
          size="small"
          placeholder="输入关键字进行过滤"
          v-model="filterText">
          <el-button slot="append" icon="el-icon-search" @click="treeFilter"></el-button>
        </el-input>
      </div>
      <div id="treeS">
          <el-tree
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :data="treeData"
          style="height:calc(100% - 42px);overflow: auto;"
          :props="defaultProps"
          node-key="id"
          highlight-current
          :expand-on-click-node="false"
          @node-click="treeNodeClick"
          :filter-node-method="filterNode"
          :default-expanded-keys="defaultExpandedKeys"
          :show-checkbox="treeMsg.showCheckBox"
          :check-on-click-node="treeMsg.showCheckBox"
          :default-checked-keys="treeMsg.defaultCheckedKeys"
          :check-strictly="true"
          @check="getCheckedKeys"
          ref="tree">
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        treeMsg: {
          title: '资源管理', // 标题
          refreshTreeFlag: false, // 刷新标志
          self: 1, // 是（1）否（0）包含自身
          async: 0, // 同步树（0）异步树（1）
          showCheckBox: false, // 是否显示多选框
          onlyLeaf: true, // 是否只需要叶子节点(有多选框时使用)
          defaultCheckedKeys: [] // 默认选中
        },
        filterText: '',
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label',
          disabled: 'disabled',
        },
        parentId: '-1',
        nodeId: '',
        formLabelWidth: '120px',
        chooseTreeNode: {},
        defaultExpandedKeys: [],
        loading: false,
        breadList:[]
      }
    },
    props: {
      parentMsg: {},
      filter:{
        type:Boolean
      }
    },
    watch: {
      parentMsg:{
        handler(newValue, oldValue) {
          console.log(799);
          if (newValue.title!==undefined){
            this.treeMsg = newValue
          }
          console.log( this.treeMsg);
          this.getTemplateTree(newValue)
        },
        immediate: true
      }
    },
    mounted: function () {
      // this.getTemplateTree(false)
    },
    methods: {
      getTemplateTree (data) {
        // this.loading=true;
        this.$axios.get(
          this.$idmConfig.resources.TreeUrl
          + '?resourceId=' + this.$idmConfig.resources.parentId
          + '&self=' + this.treeMsg.self + '&async='
          + this.treeMsg.async+'&t=' + new Date().getTime()
        ).then(response => {
          console.log(response,100);
          // this.loading=false;
          if (response.data.length <= 0) {
            this.$emit('treeInfo', { 'listenParentId': '-10', 'listenParentName': '暂无' })
          } else {
            // 展开至第一级
            this.defaultExpandedKeys = [response.data[0].id];
            //顶级菜单不可选中 disabled
            // if(response.data[0].id=='-1'){
            //   response.data[0].disabled=true;
            // }
            if (response.data[0].children !== null && response.data[0].children.length > 0) {
              // 展开至第二级
              for (var i = 0; i < response.data[0].children.length; i++) {
                this.defaultExpandedKeys.push(response.data[0].children[i].id)
              }
            }
            this.treeData = response.data
            if (!data.refreshTreeFlag) {
              this.$emit('treeInfo', { 'listenParentId': response.data[0].id, 'listenParentName': response.data[0].label })
            }
            this.defaultExpandedKeys = [...new Set([...this.defaultExpandedKeys,...this.treeMsg.defaultCheckedKeys])];

            console.log(this.filter);
            // 过滤显示选中节点
            if (this.filter) {
              this.$nextTick(() => {
                this.$refs.tree.filter(1)
              })
            }
          }
        }).catch(error => {
          this.loading=false;
          console.log('error:' + error.toString())
        })
      },
      treeNodeClick (node) {
        this.breadList = []
        this.chooseTreeNode = node
        //  获取点击当节点的dom的信息
        let selectNode = this.$refs.tree.getNode(node)
                  console.log('treeNodeClick',node,selectNode)
        // 调用递归函数
        this.platform(selectNode)
        if(!!node.otherInfo){
            this.$emit('treeInfo', { 'listenParentId': node.id, 'listenParentName': node.label,'platform':node.otherInfo.platform||'' },this.breadList)
        }else{
            this.$emit('treeInfo', { 'listenParentId': node.id, 'listenParentName': node.label},this.breadList)
        }
      },
      // 获取点击的父节点的客户端类型
      platform(node) {
        if (!node.parent) {
          return
        }
        this.breadList.unshift(node.data)
        this.platform(node.parent)//调用递归
      },
      treeFilter (){
        this.$refs.tree.filter(this.filterText)
      },
      filterNode (value, data, node) {
        if (this.filter && !this.filterText) {
          return node.checked || node.indeterminate
        } else  {
          if (!value) return true;
          return data.label.indexOf(value) !== -1;
        }
      },
      getCheckedKeys (data){
        if (this.filter) {
          this.$refs.tree.filter(1)
        }
        let keys=this.$refs.tree.getCheckedKeys(false);
        // console.log(keys);
        //onlyLeaf: false,//必须全量保存，后续获取菜单需要全部获取
        //includeHalfChecked: true,//包括半选中节点
        let nodes=this.$refs.tree.getCheckedNodes(false,true);
        // console.log("nodes",nodes);
        let nodeKeys=[];
        nodes.some((val)=>{
          //去掉 -1
          if(val.id && val.id!='-1'){
            nodeKeys.push(val.id);
          }
        })
        this.$emit('getCheckedKeys', nodeKeys,this.filter)

      }
    }
  }
</script>

<style scoped>
  .about {
    padding: 10px 0;
    box-sizing: border-box;
    height: 100%;
  }

  .cContent{
    height: 100%;
    padding: 0px;
    margin: 0px;
  }
  #elInput{
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .filter-tree{
    height: 100%;
    overflow: auto;
  }
  #treeS{
    height: calc(100% - 42px);
  }
</style>



// WEBPACK FOOTER //
// src/components/ResourcesTree.vue